'use client';

import { useCallback } from 'react';

import { useAppRouter } from '@/hooks/use-app-router';

import type { IAppNavigateOptions } from '@/utils/navigation/app-navigate';

/**
 * 站内翻页 Hook：染色合并 + 按需 release 弹窗 → 再改 pathname。
 * 内部转调 useAppRouter，与 push/replace 行为一致；适合只需单函数导航的场景。
 *
 * @example
 * const navigate = useAppNavigate();
 * navigate(ROUTER.PROFILE);
 * navigate(ROUTER.PROFILE, { type: 'replace' });
 * navigate(`${pathname}?x=1`, { skipActivityRelease: true, preserveDye: false }); // 仅 scrub
 */
export function useAppNavigate() {
    const router = useAppRouter();

    return useCallback(
        (href: string, options?: IAppNavigateOptions) => {
            const { type = 'push', scroll, preserveDye, skipActivityRelease } = options ?? {};
            const navOptions = { scroll, preserveDye, skipActivityRelease };
            if (type === 'replace') {
                router.replace(href, navOptions);
                return;
            }
            router.push(href, navOptions);
        },
        [router]
    );
}
